import gql from 'graphql-tag'
export default gql`
  mutation updateUserPassword(
    $id: Int!
    $token: String!
    $currentPassword: String!
    $newPassword: String!
  ) {
    updateUser(
      id: $id
      token: $token
      currentPassword: $currentPassword
      newPassword: $newPassword
      changePassword: 0
    )
  }
`
